export default __webpack_public_path__ + "static/media/Wolf Tooth Pendant.89ece486.jpg";